var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48 2.25 5.332 4.933 3.187 2.25A.668.668 0 0 0 2 2.667v10C2 13.402 2.598 14 3.333 14h9.334c.735 0 1.333-.598 1.333-1.333v-10a.668.668 0 0 0-1.187-.417l-2.146 2.683L8.52 2.25c-.254-.316-.788-.316-1.042 0M3.332 12.667v-1.334h9.334v1.334zm6.813-6.25c.254.316.788.316 1.042 0l1.479-1.85V10H3.333V4.567l1.48 1.85c.254.316.788.316 1.042 0L8 3.734z"
  })));
};
export default SvgCrown;